import { FeesEqualisationTreatment } from 'further-types/lp/equalisation';

const calculateEqualisationTreatmentOfFees = ({
  feeExTaxLcy,
  salesTaxPercentage,
  feesEqualisationTreatment,
  feesEqualisationTreatmentPercentage,
}: {
  feeExTaxLcy: number;
  salesTaxPercentage: number;
  feesEqualisationTreatment?: FeesEqualisationTreatment;
  feesEqualisationTreatmentPercentage?: number | null;
}) => {
  let equalisationFeeExTaxLcy = 0;
  if (feesEqualisationTreatment === FeesEqualisationTreatment.Partial) {
    const percentage = feesEqualisationTreatmentPercentage
      ? feesEqualisationTreatmentPercentage / 100
      : 1;

    equalisationFeeExTaxLcy = feeExTaxLcy * percentage;
  }

  if (feesEqualisationTreatment === FeesEqualisationTreatment.Full) {
    equalisationFeeExTaxLcy = feeExTaxLcy;
  }

  const equalisationSalesTaxAmountLcy =
    (equalisationFeeExTaxLcy * salesTaxPercentage) / 100;

  const equalisationFeeIncTaxLcy =
    equalisationFeeExTaxLcy + equalisationSalesTaxAmountLcy;

  return {
    equalisationFeeExTaxLcy,
    equalisationSalesTaxAmountLcy,
    equalisationFeeIncTaxLcy,
  };
};

export default calculateEqualisationTreatmentOfFees;
